//============================
//# rssysisyncfeature
//# Interfész szinkron interfész - interfész típus reláció (láthatóság és funkciók)
//============================

/** Interfész funkciók — az értékek az IfaceSyncFeature mezőnevei */
export enum IfaceFeature {
    // --- Lekérés funkciók (külső interfész -> TruFinance) ---
    /** Teljes downsync a kijelölt tételekre */
    DsyncSelectItems = "dsyncSelectItems",
    /** Teljes intervallumos downsync */
    DsyncInterface = "dsyncInterface",
    /** Teljes downsync összeállított lekérdezéssel */
    DsyncSendRequest = "dsyncSendRequest",
    /** Beolvasás fájlból */
    DsyncFromFile = "dsyncFromFile",
    /** Kijelölt tételek letöltése az interfészről (csak a köztes tábláig) */
    FetchSelectItems = "fetchSelectItems",
    /** Intervallumos lekérés az interfészről (csak a köztes tábláig) */
    FetchInterface = "fetchInterface",
    /** Összeállított lekérés az interfészről (csak a köztes tábláig) */
    FetchSendRequest = "fetchSendRequest",
    /** Kijelölt tételek betöltése a köztes táblából */
    LinSelectItems = "linSelectItems",
    /** Minden (status = 2) tétel betöltése a köztes táblából */
    LinInterface = "linInterface",

    // --- Feltöltés funkciók (TruFinance -> külső interfész) ---
    /** Teljes upsync a kijelölt tételekre */
    UsyncSelectItems = "usyncSelectItems",
    /** Teljes intervallumos upsync */
    UsyncInterface = "usyncInterface",
    /** Teljes upsync összeállított lekérdezéssel */
    UsyncSendRequest = "usyncSendRequest",
    /** Kijelölt köztes sorok feltöltése az interfészre */
    PushSelectItems = "pushSelectItems",
    /** Minden (status = 2) köztes sor felküldése az interfészre */
    PushInterface = "pushInterface",
    /** Kijelölt tételek újra betöltése a köztes táblába */
    LoutSelectItems = "loutSelectItems",
    /** Intervallum alapján a sorok betöltése a köztes táblába */
    LoutInterface = "loutInterface",
    /** Összeállított lekérés alapján a sorok betöltése a köztes táblába */
    LoutSendRequest = "loutSendRequest",
}

export default interface IfaceSyncFeature {
    id: number;
    /** Interfész (cssysisynciface) */
    interface: number;
    /** Interfész típusa (cssysisyncifacetyp) */
    interfaceType: number;
    /** Látható-e az interfész típus ezen az interfészen */
    visible: boolean;
    /** Teljes downsync a kijelölt tételekre engedélyezett */
    dsyncSelectItems: boolean;
    /** Teljes intervallumos downsync engedélyezett */
    dsyncInterface: boolean;
    /** Teljes downsync összeállított lekérdezéssel engedélyezett */
    dsyncSendRequest: boolean;
    /** Beolvasás fájlból engedélyezett */
    dsyncFromFile: boolean;
    /** Kijelölt tételek letöltése az interfészről (csak a köztes tábláig) engedélyezett */
    fetchSelectItems: boolean;
    /** Intervallumos lekérés az interfészről (csak a köztes tábláig) engedélyezett */
    fetchInterface: boolean;
    /** Összeállított lekérés az interfészről (csak a köztes tábláig) engedélyezett */
    fetchSendRequest: boolean;
    /** Kijelölt tételek betöltése a köztes táblából engedélyezett */
    linSelectItems: boolean;
    /** Minden (status = 2) tétel betöltése a köztes táblából engedélyezett */
    linInterface: boolean;
    /** Teljes upsync a kijelölt tételekre engedélyezett */
    usyncSelectItems: boolean;
    /** Teljes intervallumos upsync engedélyezett */
    usyncInterface: boolean;
    /** Teljes upsync összeállított lekérdezéssel engedélyezett */
    usyncSendRequest: boolean;
    /** Kijelölt köztes sorok feltöltése az interfészre engedélyezett */
    pushSelectItems: boolean;
    /** Minden (status = 2) köztes sor felküldése az interfészre engedélyezett */
    pushInterface: boolean;
    /** Kijelölt tételek újra betöltése a köztes táblába engedélyezett */
    loutSelectItems: boolean;
    /** Intervallum alapján a sorok betöltése a köztes táblába engedélyezett */
    loutInterface: boolean;
    /** Összeállított lekérés alapján a sorok betöltése a köztes táblába engedélyezett */
    loutSendRequest: boolean;
}

export const IfaceSyncFeatureDefaultProps: IfaceSyncFeature = {
    id: 1,
    interface: 1,
    interfaceType: 1,
    visible: false,
    dsyncSelectItems: false,
    dsyncInterface: false,
    dsyncSendRequest: false,
    dsyncFromFile: false,
    fetchSelectItems: false,
    fetchInterface: false,
    fetchSendRequest: false,
    linSelectItems: false,
    linInterface: false,
    usyncSelectItems: false,
    usyncInterface: false,
    usyncSendRequest: false,
    pushSelectItems: false,
    pushInterface: false,
    loutSelectItems: false,
    loutInterface: false,
    loutSendRequest: false,
}
